import { Outlet, NavLink, useNavigate } from 'react-router-dom'
import { useQuery } from '@apollo/client'
import { GET_ESTADISTICAS } from '../graphql/queries'
import './Layout.css'

function Layout({ onLogout }) {
  const navigate = useNavigate()
  const { data } = useQuery(GET_ESTADISTICAS, {
    pollInterval: 60000 // Actualizar cada minuto
  })

  const usuario = JSON.parse(localStorage.getItem('usuario') || '{}')
  const solicitudesPendientes = data?.estadisticas?.solicitudes_pendientes || 0

  const handleLogout = () => {
    onLogout()
    navigate('/login')
  }

  return (
    <div className="layout">
      {/* Sidebar */}
      <aside className="sidebar">
        <div className="sidebar-header">
          <h1 className="sidebar-logo">Factufy</h1>
          <span className="sidebar-subtitle">Gestión de Licencias</span>
        </div>

        <nav className="sidebar-nav">
          <NavLink to="/" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">📊</span>
            <span>Dashboard</span>
          </NavLink>

          <NavLink to="/comercios" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">🏢</span>
            <span>Comercios</span>
          </NavLink>

          <NavLink to="/solicitudes" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">📝</span>
            <span>Solicitudes</span>
            {solicitudesPendientes > 0 && (
              <span className="nav-badge">{solicitudesPendientes}</span>
            )}
          </NavLink>

          <NavLink to="/pagos" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
            <span className="nav-icon">💳</span>
            <span>Pagos</span>
          </NavLink>
        </nav>

        <div className="sidebar-footer">
          <div className="user-info">
            <div className="user-avatar">
              {usuario.nombre?.charAt(0)?.toUpperCase() || 'U'}
            </div>
            <div className="user-details">
              <span className="user-name">{usuario.nombre || 'Usuario'}</span>
              <span className="user-role">{usuario.rol || 'usuario'}</span>
            </div>
          </div>
          <button className="btn-logout" onClick={handleLogout}>
            Cerrar Sesión
          </button>
        </div>
      </aside>

      {/* Main Content */}
      <main className="main-content">
        <Outlet />
      </main>
    </div>
  )
}

export default Layout
